import React from "react";

export const ExplanationPyramidEn = () => {
  return (
    <>
      <h1 className="text-2xl font-bold text-gray-900 mb-4 mt-4">How a Pyramid Scheme Works</h1>

      <h3 className="mt-2"><strong>Step 1: The Scheme is Created</strong></h3>
      <ul>
        <li>A founder or leader starts the scheme and presents it as an investment or business opportunity.</li>
        <li>Participants are promised high returns for recruiting others rather than selling a product or service.</li>
      </ul>

      <h3 className="mt-2"><strong>Step 2: Early Participants Join</strong></h3>
      <ul>
        <li>The first recruits invest money to join the scheme.</li>
        <li>Their money goes to the founder or top-level members.</li>
        <li>They are then told to recruit others to earn returns.</li>
      </ul>

      <h3 className="mt-2"><strong>Step 3: Growth Through Recruitment</strong></h3>
      <ul>
        <li>New recruits must pay to join, and their money is used to pay earlier members.</li>
        <li>The scheme grows exponentially, requiring more and more recruits at each level.</li>
      </ul>

      <h3 className="mt-2"><strong>Step 4: Unsustainability Becomes Obvious</strong></h3>
      <ul>
        <li>Eventually, the number of new recruits slows down, but the scheme requires continuous growth.</li>
        <li>The bottom levels struggle to recruit, meaning most participants lose their money.</li>
      </ul>

      <h3 className="mt-2"><strong>Step 5: The Collapse</strong></h3>
      <ul>
        <li>Once recruitment stops, the cash flow dries up.</li>
        <li>Those at the bottom lose their investment, and the scheme falls apart.</li>
        <li>The top organizers may disappear with the remaining funds, or authorities may intervene.</li>
      </ul>

      <h3 className="mt-2"><strong>Key Signs of a Pyramid Scheme</strong></h3>
      <ul>
        <li>1. Emphasis on recruiting rather than selling a real product or service.</li>
        <li>2. High upfront investment fees with promises of big returns.</li>
        <li>3. Mathematically unsustainable growth—eventually, there aren’t enough new people to recruit.</li>
        <li>4. Most participants lose money, with only top-level members benefiting.</li>
      </ul>
    </>
  );
};
